import { styled } from '@mui/material/styles';
import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

const UpdateButton = styled(LoadingButton)<LoadingButtonProps>(({ theme }) => ({
  borderRadius: 8,
}));

export default UpdateButton;
